import "./index.css";
import React, { Component, Fragment } from "react";
import VideoPlayer from "./components/VideoPlayer";
import ProductLocation from "./components/ProductLocation";
import { VIDEO_UPLOAD, YOUTUBE_URL } from "../../Constants/types";
import premiumIcon from "../../assets/media/icons/premium.png";
import PinIcon from "../../assets/media/products/pin.png";
import StatusButton from "../StatusButton";
import ProductPrice from "./components/ProductPrice";
import ProductBanner from "./components/ProductBanner";

const PREMIUM_MEMBER_UPGRADE = "Premium Member Upgrade";

class Package extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: props.data,
    };
  }
  componentWillReceiveProps(nextProps) {
    const { data } = nextProps;
    this.setState({ data });
  }

  onEdit = (event) => {
    event.stopPropagation();
    const { onEdit } = this.props;
    onEdit();
  };

  formatPackageName = () => {
    const { brandId } = this.props;
    const { customNameByBrand, caption } = this.state.data;

    if (customNameByBrand && customNameByBrand[brandId])
      return customNameByBrand[brandId];
    return caption;
  };

  render() {
    const { data } = this.state;
    const { caption, description, media, contents, visibility, address } = data;
    const { onClick, white, hex, isEcoPackage, territory } = this.props;

    const isVideo =
      (media && media[0].mediaType === YOUTUBE_URL) ||
      (media && media[0].mediaType === VIDEO_UPLOAD);

    const isEditable =
      process.env.REACT_APP_USER === "admin" ||
      !caption.toLowerCase().includes("demo product");

    return (
      <div className="package_item_container package">
        <ProductBanner isEcoPackage={isEcoPackage} product={data} />
        <div className="img_container">
          {address && <img src={PinIcon} alt="pin" className="package__pin" />}
          {isVideo ? (
            <VideoPlayer
              src={media[0].mediaUrl}
              isUploadedVideo={media[0].mediaType === VIDEO_UPLOAD}
              className="product__video-player"
            />
          ) : (
            <div
              style={{
                width: "100%",
                height: 100,
                marginBottom: 10,
                backgroundImage:
                  caption !== PREMIUM_MEMBER_UPGRADE
                    ? media
                      ? `url(${media[0].mediaUrl})`
                      : "none"
                    : "none",
                backgroundColor: hex,
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                backgroundPosition: "center",
                color: white ? "white" : "black",
                borderRadius: 20,
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {caption === PREMIUM_MEMBER_UPGRADE ? (
                <Fragment>
                  <img src={premiumIcon} width="70px" alt="premium icon" />
                  <p style={{ fontSize: 30, lineHeight: 1, marginLeft: 10 }}>
                    Premium
                    <br /> Member
                  </p>
                </Fragment>
              ) : null}
            </div>
          )}
          <p className="caption">{this.formatPackageName()}</p>
          <ProductLocation address={address} />
        </div>
        <p className="description">{description}</p>
        {contents && (
          <div className="package_content">
            {contents &&
              contents
                .split("\n")
                .slice(0, 4)
                .map((item, key) => {
                  return <p key={key}>{item !== "-" ? item : ""}</p>;
                })}
          </div>
        )}
        <ProductPrice product={data} territory={territory} />
        <div className="status-container">
          <StatusButton
            isPublic={visibility}
            onClick={onClick}
            isDisabled={false}
            className={`package__status ${
              visibility ? "" : "package__status--gray"
            }`}
          />
          <button
            type="button"
            className="btn btn-secondary"
            data-toggle="modal"
            data-target="#edit_package_popup"
            disabled={!isEditable}
            onClick={isEditable ? this.onEdit : null}
          >
            {isEditable ? "Edit" : "Preview"}
          </button>
        </div>
      </div>
    );
  }
}

export default Package;



// WEBPACK FOOTER //
// ./src/components/Package/index.js